import { Box, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { checkIsBase64, removeMime } from '../../lib/helpers'
import LoadableImage from '../LoadableImage'

const PhotoToShow = ({ photoURL }: { photoURL: string }) => {
  const { t } = useTranslation()
  return (
    <Paper
      sx={(theme) => ({
        padding: theme.spacing(7.5, 0),
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexGrow: '1',
        backgroundColor: '#000',
        flexDirection: 'column',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      })}
      square
    >
      {checkIsBase64(removeMime(photoURL)) || !photoURL ? (
        <Box
          component="img"
          src={photoURL}
          sx={{
            objectFit: 'contain',
            width: '100%',
            height: ' 100%',
          }}
          alt={t('alt.content_to_show')}
        />
      ) : (
        <LoadableImage
          blobId={photoURL}
          sx={{
            objectFit: 'contain',
            width: '100%',
            height: '100%',
          }}
          alt={t('alt.content_to_show')}
        />
      )}
    </Paper>
  )
}

export default PhotoToShow
